import { getLastStepInSubgraph } from './getLastStepInSubgraph.js';

// Chain multiple disconnected subgraphs into a single sequence: each subgraph's
// tail step exits into the next subgraph's root.
export const connectSubgraphsInSequence = ({ graph, subgraphs, sourceGraph, idMap }) => {
  for (let i = 0; i < subgraphs.length - 1; i++) {
    const currentSubgraph = subgraphs[i];
    const nextSubgraph = subgraphs[i + 1];
    const lastStepInSubgraph = getLastStepInSubgraph(currentSubgraph, sourceGraph);

    if (lastStepInSubgraph && graph[idMap[lastStepInSubgraph]]) {
      graph[idMap[lastStepInSubgraph]] = {
        ...graph[idMap[lastStepInSubgraph]],
        exit: idMap[nextSubgraph.root]
      };
    }
  }

  return graph;
};
